module.exports = __webpack_public_path__ + "img/discussion-icon-right.9e0aca41.png";